/**
 * Widgets included in refresh-all: chart, KPI, and embedded dashboards (not full report embeds).
 */
export function isWidgetRefreshable(widget) {
  if (!widget?.id) return false;

  const normalizedType = (
    widget.chart_type ||
    widget.type ||
    widget.widget_type ||
    ''
  ).toLowerCase();

  if (normalizedType === 'report') {
    return false;
  }

  if (normalizedType === 'dashboard') {
    return !!(widget.parent_id || widget.dashboard_id);
  }

  if (normalizedType === 'kpi' || normalizedType === 'chart') {
    return true;
  }

  const parentId = widget.parent_id || widget.report_id;
  return !!parentId;
}

export function getRefreshableWidgetsSorted(widgets) {
  return [...(widgets || [])]
    .filter(isWidgetRefreshable)
    .sort((a, b) => (a.sort_order || 999999) - (b.sort_order || 999999));
}

/** Refresh widgets one at a time in sort_order. */
export async function refreshWidgetsSequentially(widgets, refreshOne) {
  const list = getRefreshableWidgetsSorted(widgets);
  for (const widget of list) {
    await refreshOne(widget);
  }
}
